module.exports = __webpack_public_path__ + "static/media/bg-custom-services-mob@2x.199e84f0.png";